import { render, staticRenderFns } from "./NotesDetail.vue?vue&type=template&id=22fc5506"
import script from "./NotesDetail.vue?vue&type=script&lang=js"
export * from "./NotesDetail.vue?vue&type=script&lang=js"
import style0 from "./NotesDetail.vue?vue&type=style&index=0&id=22fc5506&prod&lang=less"
import style1 from "./NotesDetail.vue?vue&type=style&index=1&id=22fc5506&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports